import React from 'react';
import { useTranslation } from 'react-i18next';

import { NextImage, Typography } from '@/shared/components/atoms';

import AgroFrutos from '~/images/partners/AgroFrutos.png';
import Amza from '~/images/partners/Amza.png';
import Cima from '~/images/partners/Cima.png';
import Daltex from '~/images/partners/Daltex.png';
import FATA from '~/images/partners/FATA.png';
import FruitValley from '~/images/partners/FruitValley.png';
import Magrabi from '~/images/partners/Magrabi.png';
import PaschaRoots from '~/images/partners/PaschaRoots.png';

const Trusted = () => {
  const { t } = useTranslation('payment');

  const imagesList = [
    {
      src: Daltex,
      width: 40,
    },
    {
      src: Magrabi,
      width: 120,
    },
    {
      src: Amza,
      width: 125,
    },
    {
      src: FruitValley,
      width: 140,
    },
    {
      src: FATA,
      width: 92,
    },
    {
      src: AgroFrutos,
      width: 177,
    },
    {
      src: Cima,
      width: 110,
    },
    {
      src: PaschaRoots,
      width: 56,
    },
  ];

  return (
    <div className='my-32 flex w-full flex-col items-center gap-40 rounded-2xl bg-white p-32'>
      <Typography weight='semiBold' variant='h3' className='text-grey-900'>
        {t('trusted-by')}
      </Typography>
      <div className='flex w-full flex-wrap items-center justify-center gap-32'>
        {imagesList.map((image, idx) => (
          <div key={`partner${idx}`}>
            <NextImage
              width={image.width}
              height={48}
              src={image.src}
              alt='partner'
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export { Trusted };
